<div class="bg-yellow-300 text-center p2">
  Prefund Development Build {{ buildInfo.version }}-{{
    buildInfo.commitHash
  }}
  isPro: {{ authService.isPro }}
</div>
